import PaymentCategories from '../../../enums/PaymentCategories';
import attributes from '../../tracking/attributes';
import bigQueryMetricRecorder from '../../tracking/bigQueryMetricRecorder';
import Track from '../../utils/tracking';
import * as types from '../action-types';

const setPaymentCategory = category => ({
  type: types.SET_PAYMENT_CATEGORY,
  category,
});

export default (category, hasPaymentOptionAbovePaymentCategorySelectBoxesBeenSelected = false) => (dispatch) => {
  const categoryToTrack = hasPaymentOptionAbovePaymentCategorySelectBoxesBeenSelected ? 'OPTION_ABOVE_CATEGORY_SELECT_BOXES' : category?.description || PaymentCategories.NONE.description;

  try {
    bigQueryMetricRecorder('selectPaymentMethodCategory',
      [attributes.getAttribute('paymentMethodCategory', categoryToTrack)]);
  } catch (error) {
    Track.track(error);
  }
  dispatch(setPaymentCategory(category));
};
